import {Directive, ElementRef, HostListener, Renderer} from '@angular/core';

@Directive({
  selector: '[appInputFocus]'
})
export class InputFocusDirective {

  constructor(private el: ElementRef, private renderer: Renderer) {
  }

  @HostListener('click') onClick() {
    this.el.nativeElement.style.color = 'green';
    this.el.nativeElement.setSelectionRange(0, this.el.nativeElement.value.length);
  }

}



// WEBPACK FOOTER //
// ./src/app/directive/input-focus.directive.ts